import React from 'react'
import { Nav } from '../components/Nav'
import { Content } from '../components/Content'
import { Footer } from '../components/Footer'

const Dashboard = () => {
  return (
    <>
      <Nav />
      <Content />
      <Footer />
    </>
  )
}

export default Dashboard;
